import React, { Component } from 'react';
import { default as ReactModal } from 'react-modal';
import Select from 'react-select';

import EmailAppliedBody from '../components/EmailAppliedBody'
import EmailPruebaBody from '../components/EmailPruebaBody'
import EmailRevisandoBody from '../components/EmailRevisandoBody'


import { CircularProgress } from 'material-ui/Progress';

import TopBar from '../components/TopBar'
import fire from '../firebase';

import moment from 'moment';
import 'moment/locale/es';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: '-15%',
        marginRight: '-50%',
        transform: 'translate(-50%, 0%)',
        width: '53%',
        height: '90%'
    }
};
var selectOptions = []

class Correos2 extends Component {


    INITIAL_STATE = {
        emailAppliedBody: "",
        emailRevisandoBody: "",
        goodbye: "",
        isLoading: false,
        hasTyped: false,

        selectedIndex: -1,
        selectedOption: -1,
        displayOption: 'Selecciona'
    }

    constructor(props) {
        super(props);

        this.state = this.INITIAL_STATE
    }
    componentDidMount() {
        fire.firestore().collection('emailTemplates').doc("emailApplied").get().then((email) => {
            this.setState({
                emailAppliedBody: email.data().body
            })
        })

        fire.firestore().collection('pruebas').get().then((pruebas) => {
            var index = 0
            selectOptions = []
            pruebas.forEach((prueba) => {
                selectOptions.push({ value: prueba.id, label: prueba.data().nombre, index: index, pruebaData: prueba.data() })
                index++
            })
            this.setState({})
        })

        fire.firestore().collection('emailTemplates').doc("emailRevisando").get().then((email) => {
            this.setState({
                emailRevisandoBody: email.data().body,
                goodbye:  email.data().goodbye || "",
            })
        })
    }
    openModal = () => {
        this.setState({
            modalIsOpen: true
        })
    }
    closeModal = () => {
        this.setState({
            modalIsOpen: false, 
            recoverEmail: ""
        })
    }
    openModal2 = () => {
        this.setState({
            modalIsOpen2: true
        })
    }
    closeModal2 = () => {
        this.setState({
            modalIsOpen2: false, 
            recoverEmail: ""
        })
    }
    openModal3 = () => {
        this.setState({
            modalIsOpen3: true
        })
    }
    closeModal3 = () => {
        this.setState({
            modalIsOpen3: false, 
            recoverEmail: ""
        })
    }
    handleSelection = (selectedOption) => {
        this.setState({ selectedOption: selectedOption.value, displayOption: selectedOption.label, selectedIndex: selectedOption.index });
    }
    handleFormInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value, hasTyped: event.target.id });
    }

    handlePruebaInputChange1 = (e) => {
        selectOptions[this.state.selectedIndex].pruebaData.emailBody = e.target.value
        this.setState({ hasTyped: "1" })
    }
    handlePruebaInputChange2 = (e) => {
        selectOptions[this.state.selectedIndex].pruebaData.emailBody2 = e.target.value
        this.setState({ hasTyped: "1" })
    }

    saveEmailAppliedBody = (event) => {
        event.preventDefault()

        this.setState({ isLoading: 0 })
        fire.firestore().collection('emailTemplates').doc("emailApplied").set({
            body: this.state.emailAppliedBody
        },
            { merge: true }).then(() => {
                window.alert("El nueva cuerpo ha sido guardada")
                this.setState({ isLoading: false })
            }).catch(error => {
                window.alert("Hubo un error, por favor intente de nuevo")
                this.setState({ isLoading: false, hasTyped: false })
            })
    }
    saveEmailPruebaBody = (event) => {
        event.preventDefault()

        this.setState({ isLoading: 1 })
        fire.firestore().collection('pruebas').doc(selectOptions[this.state.selectedIndex].value).set({
            emailBody: selectOptions[this.state.selectedIndex].pruebaData.emailBody,
            emailBody2: selectOptions[this.state.selectedIndex].pruebaData.emailBody2,
        },
            { merge: true }).then(() => {
                window.alert("El nueva cuerpo ha sido guardada")
                this.setState({ isLoading: false, hasTyped: false })
            }).catch(error => {
                window.alert("Hubo un error, por favor intente de nuevo")
                this.setState({ isLoading: false })
            })
    }
    saveEmailRevisandoBody = (event) => {
        event.preventDefault()

        this.setState({ isLoading: 2 })
        fire.firestore().collection('emailTemplates').doc("emailRevisando").set({
            body: this.state.emailRevisandoBody,
            goodbye: this.state.goodbye
        },
            { merge: true }).then(() => {
                window.alert("El nueva cuerpo ha sido guardada")
                this.setState({ isLoading: false, hasTyped: false })
            }).catch(error => {
                window.alert("Hubo un error, por favor intente de nuevo")
                this.setState({ isLoading: false })
            })
    }

    setEmailAppliedBody = () => {
        var emailBody = this.state.emailAppliedBody
        var components = ""

        if (emailBody.includes("\n")) {
            emailBody.split("\n").forEach(paragraph => {
                components += `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + paragraph + `</p>`
            })
        }
        else
            components += `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + emailBody + `</p>`
        return (
            `
        <!DOCTYPE html>
<html>
  <head>
    <title>Email</title>
    <link rel="stylesheet" type="text/css" href="css/style.css">
    <style type="text/css">
      @font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afT3GLQjUwkQ1OQ.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afTzGLQjUwkQ1OQ.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afTLGLQjUwkQ.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
    </style>
  </head>
  <body>
    <div class="container" style="max-width:800px;width:100%;">
      <div class="header center pt-10 pb-10 pl-9 pr-9" style='padding-left:9%;padding-right:9%;padding-top:10%;padding-bottom:10%;background:url("http://sisu.mx/images/vacantes/azul-correo.png");text-align:center;'>
        <img class="logo margin-bottom-20" src="http://sisu.mx/images/vacantes/logo-blanco.png" style="margin-bottom:1.25em;max-width:80%;">
        <p class="font-24 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:24px;font-size:1.5rem;color:white;'>Aplicaste a ` + ">VACANTE<" + `</p>
      </div>
      <div class="content pt-5 pb-5 pl-9 pr-9" style="padding-top:5%;padding-bottom:5%;padding-left:9%;padding-right:9%;">
        <p class="font-30 margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:30px;font-size:1.875rem;margin-bottom:.625em;'>` + ">NOMBRE<" + `,</p>
        `+ components + `
      </div>
      <table class="footer pt-2 pb-2 pl-9 pr-9" style="padding-top:2%;padding-bottom:2%;padding-left:9%;padding-right:9%;width:100%;margin-top:1.2em;padding:3% 9%;margin:0;background:#424242;color:white;">
        <tr>
          <td>
            <img src="http://sisu.mx/images/vacantes/logo-sisu-bw.png?dl=0" style="max-width:80%;"/>
          </td>
          <td class="contactos" style="text-align:right;">
            <div class="contacto">
              <p class="name font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:18px;font-size:1.125rem;font-weight:400;'></p>
              <p class="email font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:18px;font-size:1.125rem;font-weight:300;color:white;'><a  style='color:black;font-family:"Lato",sans-serif;color:white;text-decoration:none;'></a></p>
              <p class="email font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:18px;font-size:1.125rem;font-weight:300;color:white;'></p>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </body>
</html>
        `
        )
    }

    setEmailPruebaBody = () => {
        var emailBody = ""
        var emailBody2 = ""
        if (this.state.selectedIndex !== -1) {
            emailBody = selectOptions[this.state.selectedIndex].pruebaData.emailBody
            emailBody2 = selectOptions[this.state.selectedIndex].pruebaData.emailBody2
        }
        var components = ""
        var components2 = ""

        if (emailBody.includes("\n")) {
            emailBody.split("\n").forEach(paragraph => {
                components += `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + paragraph + `</p>`
            })
        }
        else
            components = `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + emailBody + `</p>`
        if (emailBody2.includes("\n")) {
            emailBody2.split("\n").forEach(paragraph => {
                components2 += `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + paragraph + `</p>`
            })
        }
        else
            components2 = `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + emailBody2 + `</p>`

        return (
            `
        <!DOCTYPE html>
        <html>
          <head>
            <title>Email</title>
            <link rel="stylesheet" type="text/css" href="css/style.css">
            <style type="text/css">
              @font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afT3GLQjUwkQ1OQ.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afTzGLQjUwkQ1OQ.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afTLGLQjUwkQ.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
            </style>
          </head>
          <body>
            <div class="container" style="max-width:800px;width:100%;">
              <div class="header center pt-10 pb-10 pl-9 pr-9" style='padding-left:9%;padding-right:9%;padding-top:10%;padding-bottom:10%;background:url("http://sisu.mx/images/vacantes/azul-correo.png");text-align:center;'>
                <img class="logo margin-bottom-20" src="http://sisu.mx/images/vacantes/logo-blanco.png" style="margin-bottom:1.25em;max-width:80%;">
                <p class="font-24 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:24px;font-size:1.5rem;color:white;'>Prueba en casa: ` + this.state.displayOption + `</p>
              </div>
              <div class="content pt-5 pb-5 pl-9 pr-9" style="padding-top:5%;padding-bottom:5%;padding-left:9%;padding-right:9%;">
                <p class="font-30 margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:30px;font-size:1.875rem;margin-bottom:.625em;'>` + ">NOMBRE<" + `,</p>
                ` + components + `
                <a href="" class="center boton  light padding-10 font-25 margin-top-10 margin-bottom-10" style='color:black;text-decoration:none;font-family:"Lato",sans-serif;font-weight:300;font-size:25px;font-size:1.5625rem;margin-top:.625em;margin-bottom:.625em;padding:.625em;text-align:center;background:#EFEFEF;display:block;'>Entrar a dashboard</a>
                <p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>La prueba estará disponible para ti hasta el XX a las XX. </p>
                ` + components2 + `
      </div>
      <table class="footer pt-2 pb-2 pl-9 pr-9" style="padding-top:2%;padding-bottom:2%;padding-left:9%;padding-right:9%;width:100%;margin-top:1.2em;padding:3% 9%;margin:0;background:#424242;color:white;">
        <tr>
          <td>
            <img src="http://sisu.mx/images/vacantes/logo-sisu-bw.png?dl=0" style="max-width:80%;"/>
          </td>
          <td class="contactos" style="text-align:right;">
            <div class="contacto">
              <p class="name font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:18px;font-size:1.125rem;font-weight:400;'></p>
              <p class="email font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:18px;font-size:1.125rem;font-weight:300;color:white;'><a  style='color:black;font-family:"Lato",sans-serif;color:white;text-decoration:none;'></a></p>
              <p class="email font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:18px;font-size:1.125rem;font-weight:300;color:white;'></p>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </body>
</html>
        `
        )
    }

    setEmailRevisandoBody = () => {
        var emailBody = this.state.emailRevisandoBody
        var components = ""

        if (emailBody.includes("\n")) {
            emailBody.split("\n").forEach(paragraph => {
                components += `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + paragraph + `</p>`
            })
        }
        else   
            components = `<p class="font-20 light margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:20px;font-size:1.25rem;margin-bottom:.625em;'>` + emailBody + `</p>`
        return (
            `
        <!DOCTYPE html>
<html>
  <head>
    <title>Email</title>
    <link rel="stylesheet" type="text/css" href="css/style.css">
    <style type="text/css">
      @font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:300;src:local("Muli Light"),local("Muli-Light"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adZnkOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afT3GLQjUwkQ1OQ.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afTzGLQjUwkQ1OQ.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:400;src:local("Muli Regular"),local("Muli-Regular"),url(https://fonts.gstatic.com/s/muli/v12/7Auwp_0qiz-afTLGLQjUwkQ.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:600;src:local("Muli SemiBold"),local("Muli-SemiBold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-ade3iOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCr2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+1EA0-1EF9,U+20AB}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCv2z24PMFk-0g.woff2) format("woff2");unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:'Muli';font-style:normal;font-weight:700;src:local("Muli Bold"),local("Muli-Bold"),url(https://fonts.gstatic.com/s/muli/v12/7Au_p_0qiz-adYnjOCX2z24PMFk.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
    </style>
  </head>
  <body>
    <div class="container" style="max-width:800px;width:100%;">
      <div class="header center pt-10 pb-10 pl-9 pr-9" style='padding-left:9%;padding-right:9%;padding-top:10%;padding-bottom:10%;background:url("http://sisu.mx/images/vacantes/azul-correo.png");text-align:center;'>
        <img class="logo margin-bottom-20" src="http://sisu.mx/images/vacantes/logo-blanco.png" style="margin-bottom:1.25em;max-width:80%;">
        <p class="font-24 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:24px;font-size:1.5rem;color:white;'>Aplicaste a ` + ">VACANTE<" + `</p>
      </div>
      <div class="content pt-5 pb-5 pl-9 pr-9" style="padding-top:5%;padding-bottom:5%;padding-left:9%;padding-right:9%;">
        <p class="font-30 margin-bottom-10" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:30px;font-size:1.875rem;margin-bottom:.625em;'>` + ">NOMBRE<" + `,</p>
        `+ components + `
      </div>
      <table class="footer pt-2 pb-2 pl-9 pr-9" style="padding-top:2%;padding-bottom:2%;padding-left:9%;padding-right:9%;width:100%;margin-top:1.2em;padding:3% 9%;margin:0;background:#424242;color:white;">
        <tr>
          <td>
            <img src="http://sisu.mx/images/vacantes/logo-sisu-bw.png?dl=0" style="max-width:80%;"/>
          </td>
          <td class="contactos" style="text-align:right;">
            <div class="contacto">
              <p class="name font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-weight:300;font-size:18px;font-size:1.125rem;font-weight:400;'></p>
              <p class="email font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:18px;font-size:1.125rem;font-weight:300;color:white;'><a  style='color:black;font-family:"Lato",sans-serif;color:white;text-decoration:none;'></a></p>
              <p class="email font-18 light" style='margin:0;font-size:1.125rem;line-height:1.2;font-family:"Lato",sans-serif;font-size:18px;font-size:1.125rem;font-weight:300;color:white;'></p>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </body>
</html>
        `
        )
    }

    sendAppliedEmailPreview = () => {
        this.setState({isLoading: true})
        var sendEmailAplicar = fire.functions().httpsCallable('sendEmailAplicar');
        sendEmailAplicar({
            preview: true,
            recoverEmail: this.state.recoverEmail.split(","),
            emailBody: this.setEmailAppliedBody(),
        }).then(() => {
            this.closeModal()
            this.setState({isLoading: false})
        }).catch(error => {
            this.setState({isLoading: false})
            window.alert(error.message)
        })
    }
    sendPruebaEmailPreview = () => {
        this.setState({isLoading: true})
        var sendEmailAplicar = fire.functions().httpsCallable('sendEmailAplicar');
        sendEmailAplicar({
            preview: true,
            recoverEmail: this.state.recoverEmail.split(","),
            emailBody: this.setEmailPruebaBody(),
        }).then(() => {
            this.closeModal2()
            this.setState({isLoading: false})
        }).catch(error => {
            this.setState({isLoading: false})
            window.alert(error.message)
        })
    }
    sendEmailRevisandoPreview = () => {
        this.setState({isLoading: true})
        var sendEmailAplicar = fire.functions().httpsCallable('sendEmailAplicar');
        sendEmailAplicar({
            preview: true,
            recoverEmail: this.state.recoverEmail.split(","),
            emailBody: this.setEmailRevisandoBody(),
        }).then(() => {
            this.closeModal3()
            this.setState({isLoading: false})
        }).catch(error => {
            this.setState({isLoading: false})
            window.alert(error.message)
        })
    }

    render() {

        return (
            <div id="admin">

                <TopBar />

                <section id="page-title">
                    <div class="row">
                        <div class="columns medium-12 small-12  ">

                            <h1>Correos</h1>

                        </div>
                    </div>
                </section>
                <section id="candidato" class="">
                    <div class="row">
                        <div class="columns small-12  ">



                            <div style={{ borderBottom: "1px solid black" }} class="columns large-6 medium-12 small-12  ">
                                <h3>Correo de aplicación exitoso a candidato</h3>
                                <EmailAppliedBody
                                    emailAppliedBody={this.state.emailAppliedBody}
                                    handleFormInputChange={this.handleFormInputChange}
                                    onFocus={() => this.setState({ hasTyped: "0" })}
                                    saveEmailAppliedBody={this.saveEmailAppliedBody}
                                    openModal={this.openModal}
                                    isLoading={this.state.isLoading}
                                    hasTyped={this.state.hasTyped}
                                />
                                
                            </div>
                            <br></br><br></br><br></br><br></br><br></br>

                            <div style={{ borderBottom: "1px solid black" }} class="columns large-6 medium-12 small-12  ">
                                <h3>Correo de mandar prueba a candidato</h3>
                                <div class="section-title">Seleccionar prueba</div>
                                <Select style={{ marginBottom: 12 }}
                                    value={this.state.selectedOption}
                                    onChange={this.handleSelection}
                                    options={selectOptions}
                                    placeholder={this.state.displayOption}
                                >
                                </Select>
                                <p class="col-title"></p>
                                {/*this.state.selectedIndex > -1 && <div style={{ marginBottom: 18 }}>Cuerpo<textarea name="emailPruebaBody" rows="8" placeholder="Cuerpo"
                                    value={selectOptions[this.state.selectedIndex].pruebaData.emailBody}
                                    onChange={(e) => {
                                        selectOptions[this.state.selectedIndex].pruebaData.emailBody = e.target.value
                                        this.setState({ hasTyped: "1" })
                                    }}
                                onFocus={() => this.setState({ hasTyped: "1" })}
                                ></textarea></div>*/}
                                {this.state.selectedIndex > -1 && <EmailPruebaBody
                                    emailPruebaBody1={selectOptions[this.state.selectedIndex].pruebaData.emailBody}
                                    emailPruebaBody2={selectOptions[this.state.selectedIndex].pruebaData.emailBody2 || ""}
                                    displayOption={this.state.displayOption}
                                    writtenDate={"XX a las XX"}
                                    handlePruebaInputChange1={this.handlePruebaInputChange1}
                                    handlePruebaInputChange2={this.handlePruebaInputChange2}
                                    onFocus={() => this.setState({ hasTyped: "1" })}
                                    saveEmailPruebaBody={this.saveEmailPruebaBody}
                                    openModal2={this.openModal2}
                                    isLoading={this.state.isLoading}
                                    hasTyped={this.state.hasTyped}
                                />}
                            </div>
                            <br></br><br></br><br></br><br></br><br></br>


                            <div style={{ borderBottom: "1px solid black" }} class="columns large-6 medium-12 small-12  ">
                                <h3>Correo de revisión de prueba a candidato</h3>
                                <EmailRevisandoBody
                                    emailRevisandoBody={this.state.emailRevisandoBody}
                                    goodbye={this.state.goodbye}
                                    handleFormInputChange={this.handleFormInputChange}
                                    onFocus={() => this.setState({ hasTyped: "2" })}
                                    saveEmailRevisandoBody={this.saveEmailRevisandoBody}
                                    openModal3={this.openModal3}
                                    isLoading={this.state.isLoading}
                                    hasTyped={this.state.hasTyped}
                                />

                            </div>

                            <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
                        </div>





                        <ReactModal
                            isOpen={this.state.modalIsOpen}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                        >
                            <div >
                                <div dangerouslySetInnerHTML={{ __html: this.setEmailAppliedBody() }} />
                                <br></br><br></br>
                                <div style={{ borderBottom: "1px solid black" }} ></div>
                                <button onClick={this.sendAppliedEmailPreview} class="button" style={{ marginTop: 8, marginLeft: 12, backgroundColor: "#144681", color:"white" }}
                                disabled={this.state.isLoading}>
                                    Mandar correo de prueba
                                </button>
                                <input style={{marginLeft: 12, height: 42}} placeholder="Correo (comma separated)" name="recoverEmail"
                                    value={this.state.recoverEmail || ""}
                                    onChange={this.handleFormInputChange} />
                                    {this.state.isLoading && <CircularProgress size={24} />}
                            </div>

                        </ReactModal>
                        <ReactModal
                            isOpen={this.state.modalIsOpen2}
                            onRequestClose={this.closeModal2}
                            style={customStyles}
                        >
                            <div >
                                <div dangerouslySetInnerHTML={{ __html: this.setEmailPruebaBody() }} />
                                <br></br><br></br>
                                <div style={{ borderBottom: "1px solid black" }} ></div>
                                <button onClick={this.sendPruebaEmailPreview} class="button" style={{ marginTop: 8, marginLeft: 12, backgroundColor: "#144681", color:"white" }}
                                disabled={this.state.isLoading}>
                                    Mandar correo de prueba
                                </button>
                                <input style={{ marginLeft: 12, height: 42}} placeholder="Correo (comma separated)" name="recoverEmail"
                                    value={this.state.recoverEmail || ""}
                                    onChange={this.handleFormInputChange} />
                                    {this.state.isLoading && <CircularProgress size={24} />}
                            </div>

                        </ReactModal>
                        <ReactModal
                            isOpen={this.state.modalIsOpen3}
                            onRequestClose={this.closeModal3}
                            style={customStyles}
                        >
                            <div >
                                <div dangerouslySetInnerHTML={{ __html: this.setEmailRevisandoBody() }} />
                                <br></br><br></br>
                                <div style={{ borderBottom: "1px solid black" }} ></div>
                                <button onClick={this.sendEmailRevisandoPreview} class="button" style={{ marginTop: 8, marginLeft: 12, backgroundColor: "#144681", color:"white" }}
                                disabled={this.state.isLoading}>
                                    Mandar correo de prueba
                                </button>
                                <input style={{marginLeft: 12, height: 42}} placeholder="Correo (comma separated)" name="recoverEmail"
                                    value={this.state.recoverEmail || ""}
                                    onChange={this.handleFormInputChange} />
                                    {this.state.isLoading && <CircularProgress size={24} />}
                            </div>

                        </ReactModal>


                    </div>
                </section>

            </div>
        );
    }
}

export default Correos2;